// What a split is called when nobody typed the restaurant. Shared by the server and the browser
// bundle. Splits made before Oct 30, 2026 were saved as "Dinner"; they read as "The bill" too.

/** The name of a split with no restaurant. */
export const UNNAMED_VENUE = 'The bill';
/** The old name, still saved on splits made before Oct 30, 2026. */
const OLD_UNNAMED = 'Dinner';

/** True when nobody typed the restaurant: blank, "The bill", or the old "Dinner". */
export const unnamedVenue = (venue: string | undefined): boolean => {
  const v = (venue || '').trim();
  return !v || v === UNNAMED_VENUE || v === OLD_UNNAMED;
};

/** The split's name as people see it: the restaurant, or "The bill". */
export const venueName = (venue: string | undefined): string => (unnamedVenue(venue) ? UNNAMED_VENUE : (venue as string));
